/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOG_SELECTED_GOOGLE_ADDRESS = 'MFE/CHECKOUT/LOG_SELECTED_GOOGLE_ADDRESS';

export default {};
